import React, { Component } from "react";
import { connect } from "react-redux";
import defaultImage from "../../Images/dp.svg";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class ProfilePic extends Component {
  render() {
    if (this.props.user.role.id === 9) {
      return (
        <div className="mx-1">
          {this.props.user.studentData.student_photo ? (
            <div className="text-center">
              <img
                src={`${this.props.user?.studentData?.student_photo}`}
                alt=""
                className="th-br-100 "
              />
            </div>
          ) : (
            <div className="d-flex justify-content-center my-auto">
              <img src={defaultImage} alt="" className=" th-ht-44" />
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div className="mx-1">
          {this.props.user?.staffData?.staff_image ? (
            <div className="text-center">
              <img
                src={`${this.props.user?.staffData?.staff_image}`}
                alt=""
                className="th-br-100 "
              />
            </div>
          ) : (
            <div className="d-flex justify-content-center my-auto">
              <img src={defaultImage} alt="" className=" th-ht-44" />
            </div>
          )}
        </div>
      );
    }
  }
}

export default connect(mapStateToProps)(ProfilePic);
